export const teklifSiparisTypes = {
  TEKLIF: "Teklif",
  SIPARIS: "Sipariş",
};
